import { Component, OnInit } from '@angular/core';
import { PregledLotoviService } from './pregled-lotovi.service';
import { moduli } from '../../config';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pregled-lotovi',
  templateUrl: './pregled-lotovi.component.html',
  styleUrls: ['./pregled-lotovi.component.scss'],
  providers: [PregledLotoviService],
})
export class PregledLotoviComponent implements OnInit {
  tablica: any;
  poruka: string;
  datumOd = moment();
  datumDo = moment();
  odabraniProizvod: any;
  sviProizvodi: any;
  o = moment().format('YYYY-MM-DD');
  d = moment().format('YYYY-MM-DD');
  a = undefined;
  ulaz = 1;
  smjene: any;
  smjena = '';
  idFaza: any;
  idPoslovnica: any;
  arLot: any;
  stavke: any = [];
  isLoading: boolean = true;

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(private service: PregledLotoviService, private router: Router) {
    if (parseInt(localStorage.getItem('firma')) == 3) {
      this.router.navigate(['/dostavnica-hlad']);
    }
    this.smjene = [
      { id: '', naziv: 'SVE' },
      { id: 1, naziv: '1' },
      { id: 2, naziv: '2' },
      { id: 3, naziv: '3' },
    ];

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().pregledPoLotovima;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit() {
    this.prometRobe(this.o, this.d, this.a, this.ulaz, this.smjena);
    this.dohvatiSveProizvode();
  }

  prometUlaz(ulaz) {
    this.ulaz = ulaz;
    this.prometRobe(this.o, this.d, this.a, this.ulaz, this.smjena);
  }

  prometRobe(o, d, a, ulaz, smjena) {
    this.poruka = 'Učitavanje...';
    let object = {
      datumod: o,
      datumdo: d,
      artiklsifra: a,
      ulaz: ulaz,
      smjena: smjena,
    };
    //console.log(object);
    this.tablica = [];
    // if (this.odabraniProizvod == undefined) {
    //   this.poruka = "Odaberite proizvod";
    // } else {
    this.service.prometRobe(object).subscribe((res) => {
      //console.log(res);
      if (res.success == true) {
        if (res.data.length == 0) {
          this.poruka = 'Nema podataka!';
        } else {
          this.poruka = 'Učitavanje...';
        }
        for (let data of res.data) {
          this.tablica.push({
            idlotpromet: data.idlotpromet,
            sifra: data.ar_sifra,
            lot: data.ar_lot,
            naziv: data.ar_naziv,
            // 'datum': moment(data.do_datum).format('DD.MM.YYYY.'),
            datum: `${moment(this.datumOd).format('DD.MM.YYYY.')} - ${moment(
              this.datumDo
            ).format('DD.MM.YYYY.')}`,
            kolicinaUlaz: data.sumaulaznakolicina,
            kolicinaIzlaz: data.sumaizlaznakolicina,
            skladisteSifra: data.po_sifra,
            skladisteNaziv: data.po_naziv,
            dokumentBroj: data.do_broj,
            vrstaDokumenta: data.dv_sifra,
            fazaIdfaza: data.faza_idfaza,
            idposlovnica: data.idposlovnica,
            smjena: data.smjena_idsmjena,
          });
        }
      } else {
        this.poruka = 'Greška konekcije ili baze!';
      }
    });
    // }
  }

  dohvatiSveProizvode() {
    this.service.dohvatiSveProizvode({}).subscribe((res) => {
      //console.log(res);
      this.sviProizvodi = [];
      //this.sviProizvodi = res.data;
      for (let data of res.data) {
        this.sviProizvodi.push({
          id: data.ar_id,
          sifra: data.ar_sifra,
          naziv: data.ar_naziv,
        });
      }
      //console.log(this.sviProizvodi);
    });
  }

  odaberiProizvod(e) {
    //console.log(e);
    this.odabraniProizvod = e.value;
    this.a = e.value;
    this.prometRobe(this.o, this.d, this.a, this.ulaz, this.smjena);
  }

  // Promjena datuma
  onValueChangedDatumOd(e) {
    //console.log(e);
    this.datumOd = e.value;
    this.o = moment(e.value).format('YYYY-MM-DD');
    this.prometRobe(this.o, this.d, this.a, this.ulaz, this.smjena);
  }
  onValueChangedDatumDo(e) {
    //console.log(e);
    this.datumDo = e.value;
    this.d = moment(e.value).format('YYYY-MM-DD');
    this.prometRobe(this.o, this.d, this.a, this.ulaz, this.smjena);
  }
  promjenaSmjene(e) {
    //console.log(e);
    this.smjena = e.value;
    this.prometRobe(this.o, this.d, this.a, this.ulaz, this.smjena);
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }

  onCellPrepared(options) {
    //console.log(options);
    if (options.rowType == "data") {
      if (options.column.dataField === "smjena"){
        if (options.value == '1') {
          options.cellElement.classList.add('bojaSmjena1');
        }
        if (options.value == '2') {
          options.cellElement.classList.add('bojaSmjena2');
        }
        if (options.value == '3') {
          options.cellElement.classList.add('bojaSmjena3');
        }
      }
    }
  }

  onRowClick(e) {
    //console.log(e);
    if (e.rowType === 'data' && e.handled !== true) {
      var key = e.component.getKeyByRowIndex(e.rowIndex);
      var expanded = e.component.isRowExpanded(key);
      if (expanded) {
        e.component.collapseRow(key);
      } else {
        e.component.expandRow(key);
      }
    }
  }

  onSelectionChanged(e: any): void {
    //console.log(e);
    e.component.collapseAll(-1);

    //this.isLoading = false;

    if (e.currentSelectedRowKeys[0]) {
      e.component.expandRow(e.currentSelectedRowKeys[0]);

      this.idFaza = e.selectedRowsData[0].fazaIdfaza;
      this.idPoslovnica = e.selectedRowsData[0].idposlovnica;
      this.arLot = e.selectedRowsData[0].lot;

      this.dohvatiStavke();
    }
  }

  dohvatiStavke(){
    this.stavke = [];
    let podaciZaSlanje = {
      idkorisnik: Number(localStorage.getItem('idsecuser')),
      idfirma: Number(localStorage.getItem('firma')),
      faza_idfaza: this.idFaza,
      poslovnica_po_id: this.idPoslovnica,
      ar_lot: this.arLot,
      datumod: this.o,
      datumdo: this.d
    };
    //console.log(podaciZaSlanje);
    this.service.dohvati_stavke_prometRobe(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      this.isLoading = false;
      if (res.success === true) {
        this.stavke = res.data;
      }
    });
  }

  obrisiStavku(e){
    //console.log(e);
    let podaciZaSlanje = {
      idkorisnik: Number(localStorage.getItem('idsecuser')),
      idfirma: Number(localStorage.getItem('firma')),
      idlotpromet: e.data.idlotpromet,
    }
    //console.log(podaciZaSlanje);
    this.service.obrisi_stavku_prometRobe(podaciZaSlanje).subscribe(res=>{
      //console.log(res);
      if (res.success == true) {
        notify('Uspješno ste obrisali stavku.', 'success', 3000);
      } else {
        notify(res.message, 'error', 3000);
      }
    });
  }

}
